<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--클레임 처리상태-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001331') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--클레임 No.-->
							<th class="col-1">{{ getMessage_('QWCC001225') }}</th>
							<td class="col-1"><el-input v-model="clmNo" readOnly /></td>
							<!--처리단계-->
							<th class="col-1">{{ getMessage_('QWCC000963') }}</th>
							<td class="col-1">
								<el-input v-model="prcsStepClNm" readOnly />
							</td>
							<!--신청일-->
							<th class="col-1">{{ getMessage_('QWCC000979') }}</th>

							<td class="col-1">
								<el-input v-model="aplcDdCl" readOnly />
							</td>
							<!--확정일-->
							<th class="col-1">{{ getMessage_('QWCC000980') }}</th>
							<td class="col-1">
								<el-input v-model="dcsnDdCl" readOnly />
							</td>
							<!--변제대상-->
							<th class="col-1">{{ getMessage_('QWCC001332') }}</th>
							<td class="col-1">
								<el-radio
									v-model="radio"
									v-for="(item, index) in tgrpYnList"
									:key="index"
									:label="item.commCd"
									@change="changeTgRp"
									:disabled="clamMstPopUp.readOnlyAuth1"
									>{{ item.commCdName }}</el-radio
								>
							</td>
						</tr>

						<tr>
							<!-- 납품업체-->
							<th class="col-1">* {{ getMessage_('QWCC001341') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="aplCpnyCd"
												class="inputWithIcon"
												@keyup.native.delete="onDelerInPutKeyDown()"
												:readonly="clamMstPopUp.readOnlyAuth"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onDelerPopup()"></i>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<!--납품업체명-->
								<el-input v-model="aplCpnyNm" :placeholder="getMessage_('QWCC001342')" readonly />
							</td>
							<!--분담율 -->
							<th class="col-1">{{ getMessage_('QWCC001168') }}</th>
							<td class="col-1">
								<el-input v-model="dvswRt" readOnly />
							</td>
							<!--적용 분담율 -->
							<th class="col-1">{{ getMessage_('QWCC001305') }}</th>
							<td class="col-1">
								<el-input :value="aplDvswRt" @input="changeAplDvswRt" maxlength="5" :readonly="clamMstPopUp.readOnlyAuth" />
							</td>
						</tr>

						<tr>
							<!--비고 -->
							<th class="col-1">{{ getMessage_('QWCC000906') }}</th>
							<td class="col-1" colspan="3">
								<el-input v-model="rmk" maxlength="300" :readonly="clamMstPopUp.readOnlyAuth" />
							</td>

							<!--변제금액 -->
							<th class="col-1">{{ getMessage_('QWCC001295') }}</th>
							<td class="col-1">
								<el-input v-model="rpymAmt" readOnly />
							</td>
							<!--적용 변제금액 -->
							<th class="col-1">{{ getMessage_('QWCC001306') }}</th>
							<td class="col-1">
								<el-input v-model="aplRpymAmt" maxlength="10" :readonly="clamMstPopUp.readOnlyAuth" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam1: { type: Object }
	},
	components: {},
	data() {
		return {
			clmNo: '', //클래임번호
			tgrpYn: '', //변제대상
			aplCpnyCd: '', //납품업체
			aplCpnyNm: '', //납품업체명
			dvswRt: '', //분담율
			aplDvswRt: '', //적용분담율
			rpymAmt: '', //변제금액
			aplRpymAmt: '', //적용변제금액

			prcsStepClNm: '', //클레임 처리 코드명
			prcStepCl: '', //클레임 처리단계코드
			aplcDdCl: '', //클레임 신청일
			dcsnDdCl: '', //클레임 확정일
			radio: 'Y',
			rmk: '', //비고
			cpnyNm: '' //납품업체 팝업시 필요함
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setProcessInfo() {
			this.clmNo = this.clamMstPopUp.clmNo; //클레임번호
			this.tgrpYn = this.clamMstPopUp.tgrpYn; // 변제대상
			this.aplCpnyCd = this.clamMstPopUp.aplCpnyCd; //납품업체
			this.aplCpnyNm = this.clamMstPopUp.aplCpnyNm; //납품업체명
			this.dvswRt = this.clamMstPopUp.dvswRt; //분담율
			this.aplDvswRt = this.clamMstPopUp.aplDvswRt; //적용분담율
			this.rpymAmt = this.clamMstPopUp.rpymAmt; //변제금액
			this.aplRpymAmt = this.clamMstPopUp.aplRpymAmt; //적용변제금액

			this.prcStepCl = this.clamMstPopUp.prcStepCl; //처리단계코드
			this.prcsStepClNm = this.clamMstPopUp.prcsStepClNm; // 처리단계명
			this.aplcDdCl = this.clamMstPopUp.aplcDdCl; //신청일
			this.dcsnDdCl = this.clamMstPopUp.dcsnDdCl; //확정일
			this.rmk = this.clamMstPopUp.rmk; //비고
		},
		changeTgRp(value) {
			this.tgrpYn = value;
		},
		onDelerInPutKeyDown() {
			this.aplCpnyCd = '';
			this.aplCpnyNm = '';

			//분담율
			this.dvswRt = '';
			//적용 분담율
			this.aplDvswRt = '';
		},
		onDelerPopup() {
			/*납품업체팝업*/
			//console.log('이거뭐지><<<<<<<', this.clamMstPopUp.readOnlyAuth);

			if (this.clamMstPopUp.readOnlyAuth == false) {
				this.cpnyNm = this.aplCpnyNm; //납품업체 팝업시 필요한 값
				this.$emit('OpenDelPopup', this.cpnyNm);
			}
		},
		changeAplDvswRt(value) {
			this.aplDvswRt = value;

			try {
				if (value > 100) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001776'), [this.getMessage_('QWCC001305')]));
				} else {
					let tmpAplRpyAmt = convertNvl(value, '') == '' ? '' : (Number.parseInt(value) / 100) * Number.parseInt(this.rpymAmt);

					//적용변제금액  = (적용분담율 /100) * 변제금액  절삭해서 넣는다.소수점 없이.
					this.aplRpymAmt = Math.floor(tmpAplRpyAmt);
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		}
	},
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.
		try {
			//await this.getCommCodes_({ key: 'tgrpYnList', codeType: 'YN' });

			this.clmNo = this.clamMstPopUp.clmNo; //클레임번호
			this.tgrpYn = this.clamMstPopUp.tgrpYn || 'Y'; // 변제대상
			this.radio = this.clamMstPopUp.tgrpYn || 'Y'; // 변제대상 라디오 디스플레이
			this.aplCpnyCd = this.clamMstPopUp.aplCpnyCd; //납품업체
			this.aplCpnyNm = this.clamMstPopUp.aplCpnyNm; //납품업체명
			this.dvswRt = this.clamMstPopUp.dvswRt; //분담율
			this.aplDvswRt = this.clamMstPopUp.aplDvswRt; //적용분담율
			this.rpymAmt = this.clamMstPopUp.rpymAmt; //변제금액
			this.aplRpymAmt = this.clamMstPopUp.aplRpymAmt; //적용변제금액

			this.prcStepCl = this.clamMstPopUp.prcStepCl; //처리단계코드
			this.prcsStepClNm = this.clamMstPopUp.prcsStepClNm; // 처리단계명
			this.aplcDdCl = this.clamMstPopUp.aplcDdCl; //신청일
			this.dcsnDdCl = this.clamMstPopUp.dcsnDdCl; //확정일
			this.rmk = this.clamMstPopUp.rmk; //비고
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	watch: {
		sendParam1(newValue, oldValue) {
			//딜러점
			this.aplCpnyCd = this.sendParam1.cpnyCd;
			this.aplCpnyNm = this.sendParam1.cpnyNm;

			let tmpDvswRt = this.sendParam1.rtsh;

			//분담율
			this.dvswRt = tmpDvswRt;
			//적용분담율
			this.aplDvswRt = tmpDvswRt;

			let tmpAplRpyAmt = convertNvl(tmpDvswRt, '') == '' ? '' : (Number.parseInt(tmpDvswRt) / 100) * Number.parseInt(this.rpymAmt);

			//적용변제금액  = (적용분담율 /100) * 변제금액  절삭해서 넣는다.소수점 없이.
			this.aplRpymAmt = Math.floor(tmpAplRpyAmt);
		},
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateClamSave_({ key: 'clmNo', value: convertNvl(this.clmNo, '') }); // 클레임번호
				this.setStateClamSave_({ key: 'tgrpYn', value: convertNvl(this.tgrpYn, '') }); // 변제대상
				this.setStateClamSave_({ key: 'aplCpnyCd', value: convertNvl(this.aplCpnyCd, '') }); // 납품업체
				this.setStateClamSave_({ key: 'aplCpnyNm', value: convertNvl(this.aplCpnyNm, '') }); // 납품업체명
				this.setStateClamSave_({ key: 'dvswRt', value: convertNvl(this.dvswRt, '') }); // 분담율
				this.setStateClamSave_({ key: 'aplDvswRt', value: convertNvl(this.aplDvswRt, '') }); // 적용분담율
				this.setStateClamSave_({ key: 'rpymAmt', value: convertNvl(this.rpymAmt, '') }); // 변제금액
				this.setStateClamSave_({ key: 'aplRpymAmt', value: convertNvl(this.aplRpymAmt, '') }); // 적용변제금액
				this.setStateClamSave_({ key: 'prcStep', value: convertNvl(this.prcStepCl, '') }); // 클레임 처리상태코드단계코드
				this.setStateClamSave_({ key: 'prcsStepNm', value: convertNvl(this.prcsStepClNm, '') }); // 클레임 처리단계명
				this.setStateClamSave_({ key: 'rmk', value: convertNvl(this.rmk, '') }); // 클레임 처리단계명
			}
		}
	}
};
</script>
<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
